import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.unshift.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { request } from "@/js/http/http_request";
import { getClientAppData } from "@/js/http/auth.js";
import { isBreakPointMenuMobile } from "@/js/mobile/mobile";
import { tenantType } from "@/js/lists.ts";
import menuItemComponent from "./MenuItem.vue";
export default {
  name: "Menu",
  data: function data() {
    return {
      clientAppData: null,
      loaded: false,
      mainMenus: [],
      isMenuMobile: this.isBreakPointMenuMobile(),
      tenantType: tenantType
    };
  },
  beforeDestroy: function beforeDestroy() {
    if (typeof window === "undefined") return;
    window.removeEventListener("resize", this.onResize, {
      passive: true
    });
  },
  created: function created() {
    this.clientAppData = getClientAppData(this);
    if (this.logged) {
      var _this = this;
      request("/v1/menu", "get", null, true, "api").then(function (response) {
        var seen = new Set();
        _this.mainMenus = _toConsumableArray(response.data.filter(function (item) {
          var isSeen = seen.has(item.route_name);
          seen.add(item.route_name);
          return !isSeen;
        }));
        if (!_this.$whitelabel.isMyCellarEnabled && _this.mainMenus.findIndex(function (x) {
          return x.route_name == "userCellar";
        }) > -1) {
          _this.mainMenus.splice(_this.mainMenus.findIndex(function (x) {
            return x.route_name == "userCellar";
          }), 1);
        }
        if (!_this.$whitelabel.isMultipleWineries && _this.mainMenus.findIndex(function (x) {
          return x.route_name == "adminProducerList";
        }) > -1) {
          _this.mainMenus.splice(_this.mainMenus.findIndex(function (x) {
            return x.route_name == "adminProducerList";
          }), 1);
        }
        if (_this.$whitelabel.returnToCorporateWebsiteUrl) {
          _this.mainMenus.unshift({
            id_menu: 999,
            name: "<span class='fas fa-angle-double-left'></span>",
            url_blank: _this.$whitelabel.returnToCorporateWebsiteUrl,
            title: _this.$whitelabel.returnToCorporateWebsiteTitle,
            is_vhtml: true
          });
        }
        _this.menus = {};
      }).catch(function () {
        _this.$toasted.show("An error occured. Please contact an administrator.", {
          type: "error"
        });
      });
    } else {
      var _this2 = this;
      request("/v1/tenants/informations", "post", _this2.clientAppData, false, "cap").then(function (data) {
        if (data.data.tenant_type != tenantType.OWNER) {
          _this2.mainMenus = [{
            id_menu: 8,
            id_language: 0,
            name: "Subscribe",
            route_name: "subscribe"
          }, {
            id_menu: 7,
            id_language: 0,
            name: "Contact",
            route_name: "contact"
          }];
          if (_this2.$whitelabel.returnToCorporateWebsiteUrl) {
            _this2.mainMenus.unshift({
              id_menu: 999,
              name: "<span class='fas fa-angle-double-left'></span>",
              url_blank: _this2.$whitelabel.returnToCorporateWebsiteUrl,
              title: _this2.$whitelabel.returnToCorporateWebsiteTitle,
              is_vhtml: true
            });
          }
        }
      }).catch(function () {
        _this2.$toasted.show("An error occured. Please contact an administrator.", {
          type: "error"
        });
      });
    }
  },
  mounted: function mounted() {
    this.loaded = true;
    this.onResize();
    window.addEventListener("resize", this.onResize, {
      passive: true
    });
  },
  methods: {
    goHome: function goHome() {
      if (!this.logged) {
        if (this.$router.currentRoute.name != "home") {
          this.$router.push({
            name: "home"
          });
        }
      } else {
        if (this.$router.currentRoute.name != "userHome") {
          this.$router.push({
            name: "userHome"
          });
        }
      }
    },
    mobileMenuAction: function mobileMenuAction(menu_item) {
      if (menu_item.url_blank) {
        window.open(menu_item.url_blank, "_blank");
      } else {
        var query = null;
        if (menu_item.route_name === "userOrderList") query = {
          tab: "orders"
        };else if (menu_item.route_name === "adminOrderList") query = {
          tab: "orders"
        };else if (menu_item.route_name === "adminProductList") query = {
          tab: "wines"
        };else if (menu_item.route_name === "userProductList") query = {
          tab: "wines"
        };
        this.$router.push({
          name: menu_item.route_name,
          query: query
        });
      }
    },
    onResize: function onResize() {
      this.isMenuMobile = isBreakPointMenuMobile();
    },
    isBreakPointMenuMobile: isBreakPointMenuMobile
  },
  components: {
    "menu-item": menuItemComponent
  },
  props: ["logged", "dark"]
};